var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{attrs:{"id":'list-item-' + _vm.idx}},[_vm._v(_vm._s(_vm.content.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }